import React from 'react';
import { connect } from 'react-redux';

import { goTo } from '../tools';
import LoSentimosForm from '../contrato/lo-sentimos.frm';

const mapState = (state) => {
	return {
		loading: state.global.loading,
		paso: state.recuperar.paso,
		pasoAnt: state.recuperar.pasoAnt
	};
}

const mapDispatch = (dispatch,ownProps) => {
	return {
		loader: (show) => {
			dispatch({"type": "LOADER", "show": show});
		},		
		pasoRegresar: (paso) => {
		    dispatch({ "type": "RECUPERAR_SET_PASO", paso: paso});
		},
		resetPaso: () => {
			dispatch({ "type": "RECUPERAR_RESET_PASO" });
		}
	}
}

class LoSentimos extends React.Component {
	
	submit = (data) => {
		if(data.acepto == true) {
			this.props.pasoRegresar("contrato"); 
			
		} else {
			this.props.resetPaso();
			goTo("login");
			//self.window.location = "/#!/login";
		}
	}

	render() {
		return <LoSentimosForm onSubmit={this.submit} />;
	}
}

export default connect(mapState, mapDispatch)(LoSentimos);


// WEBPACK FOOTER //
// ./src/recuperar-contrasenia/loSentimos.cmpt.js